import { memo, useState, useEffect, useRef } from 'react';

const SnakeGame = memo(() => {
  const canvasRef = useRef(null);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const size = 12;
    const w = Math.floor(canvas.width / size);
    const h = Math.floor(canvas.height / size);
    let snake = [{ x: 5, y: 5 }];
    let dir = { x: 1, y: 0 };
    let food = { x: Math.floor(Math.random() * w), y: Math.floor(Math.random() * h) };
    let sc = 0;
    let running = true;

    const handleKey = (e) => {
      if (e.key === 'ArrowUp' && dir.y === 0) dir = { x: 0, y: -1 };
      if (e.key === 'ArrowDown' && dir.y === 0) dir = { x: 0, y: 1 };
      if (e.key === 'ArrowLeft' && dir.x === 0) dir = { x: -1, y: 0 };
      if (e.key === 'ArrowRight' && dir.x === 0) dir = { x: 1, y: 0 };
    };
    window.addEventListener('keydown', handleKey);

    const loop = setInterval(() => {
      if (!running) return;
      const head = { x: (snake[0].x + dir.x + w) % w, y: (snake[0].y + dir.y + h) % h };
      if (snake.some(s => s.x === head.x && s.y === head.y)) { running = false; setGameOver(true); return; }
      snake.unshift(head);
      if (head.x === food.x && head.y === food.y) {
        sc++; setScore(sc);
        food = { x: Math.floor(Math.random() * w), y: Math.floor(Math.random() * h) };
      } else snake.pop();

      ctx.fillStyle = '#0e0d0b';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#C9A84C';
      snake.forEach(s => ctx.fillRect(s.x * size, s.y * size, size - 1, size - 1));
      ctx.fillStyle = '#e06060';
      ctx.fillRect(food.x * size, food.y * size, size - 1, size - 1);
    }, 120);

    return () => { clearInterval(loop); window.removeEventListener('keydown', handleKey); };
  }, []);

  return (
    <div className="text-center">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-sans font-medium" style={{ color: 'inherit' }}>
          Snake {gameOver ? '— Game Over!' : ''}
        </span>
        <span className="text-xs font-sans" style={{ color: '#8c8782' }}>Score: {score}</span>
      </div>
      <canvas ref={canvasRef} width={264} height={264} style={{ border: '1px solid #f0ece6', display: 'block', margin: '0 auto', background: 'rgba(128,128,128,0.05)' }} />
      <p className="text-xs font-sans mt-1" style={{ color: '#bfb9b3' }}>Arrow keys to move</p>
    </div>
  );
});

SnakeGame.displayName = 'SnakeGame';
export default SnakeGame;
